module.exports = __webpack_public_path__ + "img/Stahlzaun Streifen.cb74d1e0.jpg";